import React, { ReactElement } from 'react';
import MemberPage from 'components/pages/person/list/MembersPage';
import { DisciplineEnum, ServerSideInitProps } from 'types/types';
import { ClubListItemInterface } from 'components/interfaces/ClubInterface';
import { CountryInterface } from 'components/interfaces/GeneralInterface';
import { PaginatorPageInterface } from 'components/interfaces/Paginator';
import {
    ConfigPageInterface,
    configUrlHelper,
} from 'utils/helpers/server/serverSideProps/config';
import { MemberListPageApiInterface } from 'submodules/api_middleware';
import { getMembersListData } from 'utils/helpers/server/serverSideProps/lists/member';
import { Config_PersonList_ApiInterface } from 'submodules/api_middleware/src/interfaces/config/PersonListConfigApiInterface';
import { getGlobalProps } from 'utils/helpers/server/serverSideProps/global';
import { getPageProps } from 'utils/helpers/server/serverSideProps/ssrProps';
import { getPageNamespaces } from 'utils/helpers/server/serverSideProps/translations';

interface Props
    extends PaginatorPageInterface,
        ConfigPageInterface<Config_PersonList_ApiInterface> {
    members: MemberListPageApiInterface[];
    countriesList: CountryInterface[];
    clubList: ClubListItemInterface[];
    discipline: DisciplineEnum;
}

interface ServerSideProps {
    props?: Props;
}

const Page = ({
    members,
    paginator,
    countriesList,
    clubList,
    discipline,
    config,
}: Props): ReactElement => {
    return (
        <MemberPage
            members={members}
            paginator={paginator}
            countriesList={countriesList}
            clubList={clubList}
            discipline={discipline}
            config={config}
        />
    );
};

export const getServerSideProps = async ({
    req,
    res,
    query,
}: ServerSideInitProps): Promise<ServerSideProps> => {
    // List of members can be accessed by public, hence allowNotLoggedIn = true:
    const { api } = await getGlobalProps(req, res, true);

    const config: Config_PersonList_ApiInterface =
        await configUrlHelper.person.list({ req, res, api, query });

    const response = await getMembersListData(req, res, api, query);

    const props = await getPageProps<Props>({
        givenProps: {
            paginator: response.paginator,
            members: response.persons,
            countriesList: response.countries,
            clubList: response.clubs,
            discipline: response.discipline,
            config,
        },
        req,
        res,
        api,
        query,
        nameSpaces: getPageNamespaces('/members'),
    });

    return {
        props,
    };
};

export default Page;
